import { render, staticRenderFns } from "./dosage_details.vue?vue&type=template&id=f54e5e00&scoped=true"
import script from "./dosage_details.vue?vue&type=script&lang=js"
export * from "./dosage_details.vue?vue&type=script&lang=js"
import style0 from "./dosage_details.vue?vue&type=style&index=0&id=f54e5e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54e5e00",
  null
  
)

export default component.exports